import { Player, Ranking } from '../types/game';

const RANKING_KEY = 'reaction-game-ranking';
const MAX_RANKINGS = 100;

export const saveRanking = (player: Player): void => {
  const stored = localStorage.getItem(RANKING_KEY);
  const ranking: Ranking = stored ? JSON.parse(stored) : { players: [], lastUpdated: 0 };
  
  ranking.players.push(player);
  ranking.lastUpdated = Date.now();
  
  ranking.players.sort((a, b) => b.score - a.score);
  
  if (ranking.players.length > MAX_RANKINGS) {
    ranking.players = ranking.players.slice(0, MAX_RANKINGS);
  }
  
  localStorage.setItem(RANKING_KEY, JSON.stringify(ranking));
};

export const getRanking = (): Ranking => {
  const stored = localStorage.getItem(RANKING_KEY);
  return stored ? JSON.parse(stored) : { players: [], lastUpdated: 0 };
};

export const getTopRankings = (limit: number = 10): Player[] => {
  const ranking = getRanking();
  return ranking.players.slice(0, limit);
};

export const clearRankings = (): void => {
  localStorage.removeItem(RANKING_KEY);
};